export class AverageTimeDTO {
  public averageTime: number;

  public numberOfCalls: number;

  public visitTypes: string;
}